// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__T8Hxq","inner":"Footer_inner__elVzr","nextIcon":"Footer_nextIcon__2Vmco","innerLeft":"Footer_innerLeft__vS8pN"};